<app-form-group>
    <label class="text-standard" id="label">
        <ng-content></ng-content>
        <span *ngIf="required" class="text-error">*</span>
    </label>
    <textarea class="skv-form-control" id="area" [formControl]="control" [rows]="rows" aria-describedby="label"
        placeholder="" [maxLength]="maxLength > 0 ? maxLength : null"></textarea>
    <span *ngIf="maxLength > 0">{{maxLength - length}} antal tecken kvar.</span>
    <ng-container *ngIf="error">
        <br />
        <span *ngIf="error" class="text-error text-small">{{error}}</span>
    </ng-container>
</app-form-group>